// The default vector threshold to use in automated carousels.
export const AUTO_CAROUSEL_DEFAULT_RESULTS_PER_PAGE = 24;
export const AUTO_CAROUSEL_DEBUG_RESULTS_PER_PAGE = 100;

// The minimum number of tiles an automated carousel should have before it
// becomes visible.
export const AUTO_CAROUSEL_MINIMUM_MUSIC_TILES_TO_SHOW = 3;
export const AUTO_CAROUSEL_MINIMUM_SFX_TILES_TO_SHOW = 3;

// If a category page has a manual carousel of a smaller length than this value,
// the automated carousel feature will attempt to augment the carousel with
// relevant vector matches.
export const AUTO_CAROUSEL_ADD_UP_TO_THRESHOLD = 12;
